var heading_default = {
  "fontElementMap": "G7u6H",
  "elementSpacing": "s-Oga",
  "headerOne": "dpEOn s-Oga",
  "headerTwo": "mIaD9 s-Oga",
  "headerThree": "gmp8W s-Oga",
  "headerFour": "dOejj s-Oga",
  "headerFive": "_23JEp s-Oga",
  "headerSix": "V-JaT s-Oga",
  "child": "Z6EaW"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
